import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasPermission as checkPermission } from '../utils/permissions';

interface PermissionRouteProps {
  children: React.ReactNode;
  permission?: string; // 必須的權限
  fallback?: React.ReactNode; // 沒有權限時顯示的內容
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({ children, permission, fallback }) => {
  const { user, isAuthenticated } = useAuth();

  // 如果未登入，重定向到登入頁面
  if (!isAuthenticated) {
    return <Navigate to='/login' replace />;
  }

  // 如果沒有指定權限要求，只檢查是否登入
  if (!permission) {
    return <>{children}</>;
  }

  if (!checkPermission(user, permission)) {
    // 如果提供了fallback，使用fallback
    if (fallback) {
      return <>{fallback}</>;
    }

    // 否則顯示無權限頁面
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        }}
      >
        <div
          style={{
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '3rem',
            borderRadius: '1rem',
            textAlign: 'center',
            maxWidth: '400px',
          }}
        >
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔒</div>
          <h2 style={{ color: '#d32f2f', marginBottom: '1rem' }}>沒有訪問權限</h2>
          <p style={{ color: '#666', marginBottom: '2rem' }}>
            您的帳號 ({user?.email}) 沒有訪問此功能的權限。
          </p>
          <p style={{ color: '#666', marginBottom: '2rem' }}>
            當前權限：
            <br />
            {user?.permissions?.can_access_all_features && '✅ 完整功能'}
            {!user?.permissions?.can_access_all_features && '❌ 無功能權限'}
          </p>
          <button
            onClick={() => window.history.back()}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '0.25rem',
              cursor: 'pointer',
            }}
          >
            返回上一頁
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default PermissionRoute;
